// extracted by mini-css-extract-plugin
export default {"TabContainer":"Tabs_TabContainer__vQXSI","Tabs":"Tabs_Tabs__fu9iy","Tab":"Tabs_Tab__AaDEz","activeTab":"Tabs_activeTab__UYwZt"};